module.exports = __webpack_public_path__ + "static/img/user.2e81408a.png";